import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import {Button, Dialog, Stack, Typography, styled} from '@mui/material';
import {FC} from 'react';
import {MODAL_LAYER_Z_INDEX} from '../modal-layers';

interface Props {
  open: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
}

export const MessageModal: FC<Props> = ({open, title, message, onConfirm}) => {
  return (
    <Dialog
      open={open}
      sx={{zIndex: MODAL_LAYER_Z_INDEX.feedbackModal}}
      onClose={(_, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      }}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          width: 'min(449px, calc(100vw - 32px))',
          maxWidth: 'calc(100vw - 32px)',
          m: 2,
          borderRadius: '5px',
          overflow: 'hidden',
          boxShadow: 'none',
        },
      }}
    >
      <Root justifyContent="space-between">
        <BlueBar />

        <Content>
          <TitleRow>
            <CheckCircleOutlinedIcon fontSize="large" color="inherit" />
            <Typography fontWeight={700} variant="h6">
              {title}
            </Typography>
          </TitleRow>

          <BottomSection>
            <Message>{message}</Message>

            <OkButton variant="contained" onClick={onConfirm}>
              OK
            </OkButton>
          </BottomSection>
        </Content>

        <BlueBar />
      </Root>
    </Dialog>
  );
};

const Root = styled(Stack)({
  background: '#fff',
});

const BlueBar = styled(Stack)({
  height: '16px',
  backgroundColor: '#007DFF',
});

const Content = styled(Stack)(({theme}) => ({
  padding: theme.spacing(2, 0),
  color: '#002033',
  gap: theme.spacing(1),
}));

const TitleRow = styled(Stack)(({theme}) => ({
  padding: theme.spacing(0, 3, 0, 4),
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 5.75, 0, 5.75),
  },
}));

const Message = styled(Typography)(({theme}) => ({
  fontSize: '14px',
  fontWeight: 300,
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(3),
  whiteSpace: 'pre-line',
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(11.5),
    paddingRight: theme.spacing(5.75),
  },
}));

const BottomSection = styled(Stack)(({theme}) => ({
  gap: theme.spacing(5),
}));

const OkButton = styled(Button)({
  backgroundColor: '#007DFF',
  width: '134px',
  alignSelf: 'center',
  textTransform: 'none',

  '&:hover': {
    backgroundColor: '#006be0',
  },
});
